import { enifyDateTime, getQuery, removeKeyObjects } from 'utility';
import _ from 'lodash';
import jMoment from 'moment-jalaali';
const TABLE_POD_QUERY_KEYS = ['page', 'pageSize', 'orderBy', 'orderDirection'];
export const FILTER_TYPES = {
  autocomplete: 'AUTOCOMPLETE',

  select: 'SELECT',
  selectRange: 'SELECT_RANGE',

  text: 'TEXT',
  textRange: 'TEXT_RANGE',

  date: 'DATE',
  dateRange: 'DATE_RANGE',

  time: 'TIME',
  timeRange: 'TIME_RANGE',

  dateTime: 'DATE_TIME',
  dateTimeRange: 'DATE_TIME_RANGE',
  year: 'YEAR',
  month: 'MONTH',
};

export const toFilterVOS = (filters) => {
  const res = [];
  filters.forEach((v) => {
    if (v?.id == null) return;
    if (v?.id?.hasOwnProperty('start') && v?.id?.hasOwnProperty('end')) {
      if (v.id.start == null || v.id.end == null) return;
    }

    if (v?.value === null || v?.value === '') return;
    if (v?.value?.hasOwnProperty('start') && v?.value?.hasOwnProperty('end')) {
      if (v.value.start == null && v.value.end == null) return;
    }

    switch (v?.filterType) {
      case FILTER_TYPES.dateTimeRange:
        if (v.id.start?.date && v.id.start?.time && v.id.end?.date && v.id.end?.time) {
          if (v.value.start) {
            res.push({
              id: `${v.id.start.time}`,
              value: enifyDateTime(v.value.start.format('HH:mm:ss')),
              key: v?.query?.start?.time ?? v?.query?.start ?? v?.keyName ?? null,
            });
            res.push({
              id: `${v.id.start.date}`,
              value: enifyDateTime(v.value.start.format('jYYYY/jMM/jDD')),
              key: v?.query?.start?.date ?? v?.query?.start ?? v?.keyName ?? null,
            });
          }

          if (v.value.end) {
            res.push({
              id: `${v.id.end.time}`,
              value: enifyDateTime(v.value.end.format('HH:mm:ss')),
              key: v?.query?.end?.time ?? v?.query?.end ?? v?.keyName ?? null,
            });
            res.push({
              id: `${v.id.end.date}`,
              value: enifyDateTime(v.value.end.format('jYYYY/jMM/jDD')),
              key: v?.query?.end?.date ?? v?.query?.end ?? v?.keyName ?? null,
            });
          }
        } else {
          if (v.value.start) {
            res.push({
              id: `${v.id.start}`,
              value: enifyDateTime(v.value.start.format('jYYYY/jMM/jDD HH:mm:ss')),
              key: v?.query?.start ?? v?.keyName ?? null,
            });
          }
          if (v.value.end) {
            res.push({
              id: `${v.id.end}`,
              value: enifyDateTime(v.value.end.format('jYYYY/jMM/jDD HH:mm:ss')),
              key: v?.query?.end ?? v?.keyName ?? null,
            });
          }
        }
        break;
      case FILTER_TYPES.dateRange:
        if (v.value.start) {
          res.push({
            id: `${v.id.start}`,
            value: enifyDateTime(v.value.start.format('jYYYY/jMM/jDD 00:00:00')),
            key: v?.query?.start ?? v?.keyName ?? null,
          });
        }
        if (v.value.end) {
          res.push({
            id: `${v.id.end}`,
            value: enifyDateTime(v.value.end.format('jYYYY/jMM/jDD 23:59:00')),
            key: v?.query?.end ?? v?.keyName ?? null,
          });
        }
        break;
      case FILTER_TYPES.timeRange:
        if (v.value.start) {
          res.push({
            id: `${v.id.start}`,
            value: enifyDateTime(v.value.start.format('HH:mm:ss')),
            key: v?.query?.start ?? v?.keyName ?? null,
          });
        }
        if (v.value.end) {
          res.push({
            id: `${v.id.end}`,
            value: enifyDateTime(v.value.end.format('HH:mm:ss')),
            key: v?.query?.end ?? v?.keyName ?? null,
          });
        }
        break;
      case FILTER_TYPES.selectRange:
      case FILTER_TYPES.year:
        if (v.value) {
          res.push({
            id: `${v.id}`,
            value: enifyDateTime(v.value.format('jYYYY')),
            key: v?.query ?? v?.keyName ?? null,
          });
        }
        break;

      case FILTER_TYPES.month:
        if (v.value.start) {
          res.push({
            id: `${v.id.start}`,
            value: enifyDateTime(v.value.start.format('jYYYY/jMM')),
            key: v?.query?.start ?? v?.keyName ?? null,
          });
        }
        if (v.value.end) {
          res.push({
            id: `${v.id.end}`,
            value: enifyDateTime(v.value.end.format('jYYYY/jMM')),
            key: v?.query?.end ?? v?.keyName ?? null,
          });
        }
        break;
      case FILTER_TYPES.textRange:
        if (v.value.start != null) {
          res.push({
            id: `${v.id.start}`,
            value: v.value.start,
            key: v?.query?.start ?? v?.keyName ?? null,
          });
        }
        if (v.value.end != null) {
          res.push({
            id: `${v.id.end}`,
            value: v.value.end,
            key: v?.query?.end ?? v?.keyName ?? null,
          });
        }
        break;
      case FILTER_TYPES.dateTime:
        if (v.id?.date && v.id?.time) {
          res.push({
            id: `${v.id.time}`,
            value: enifyDateTime(v.value.format('HH:mm:ss')),
            key: v?.query?.time ?? v?.query ?? v?.keyName ?? null,
          });
          res.push({
            id: `${v.id.date}`,
            value: enifyDateTime(v.value.format('jYYYY/jMM/jDD')),
            key: v?.query?.date ?? v?.query ?? v?.keyName ?? null,
          });
        } else {
          res.push({
            id: `${v.id}`,
            value: enifyDateTime(v.value.format('jYYYY/jMM/jDD HH:mm:ss')),
            key: v?.query ?? v?.keyName ?? null,
          });
        }
        break;
      case FILTER_TYPES.date:
        res.push({
          id: `${v.id}`,
          value: enifyDateTime(v.value.format('jYYYY/jMM/jDD')),
          key: v?.query ?? v?.keyName ?? null,
        });
        break;
      case FILTER_TYPES.time:
        res.push({
          id: `${v.id}`,
          value: enifyDateTime(v.value.format('HH:mm:ss')),
          key: v?.query ?? v?.keyName ?? null,
        });
        break;
      case FILTER_TYPES.select:
      case FILTER_TYPES.text:
        res.push({
          id: `${v.id}`,
          value: v.value,
          key: v?.query ?? v?.keyName ?? null,
        });
        break;
      case FILTER_TYPES.autocomplete:
        res.push({
          id: `${v.id}`,
          value: v?.value?.value,
          key: v?.query ?? v?.keyName ?? null,
        });
        break;
      default:
        break;
    }
  });

  return res;
};

export const filterVOStoQueryStrWithId = (filters) => {
  const queries = {};
  filters.forEach((v) => {
    if (v?.value !== null || v?.value === '') {
      const k = v?.id ?? null;
      if (k) {
        queries[k] = v?.value;
      }
    }
  });
  return queries;
};

export const filterVOStoQueryStr = (filters) => {
  const queries = {};
  filters.forEach((v) => {
    if (v?.value !== null || v?.value === '') {
      const k = v?.query ?? v?.keyName ?? v?.key ?? null;
      if (k) {
        queries[k] = v?.value;
      }
    }
  });
  return queries;
};

export const combineOnLeft = (newFilter, currentQuery) => {
  const mergedQueries = _.merge({ ...currentQuery }, { ...newFilter });
  return mergedQueries;
};

export const combineFilterPodQueryWith = (newFilter, query, filterPodState) => {
  const allQueries = { ...query }; // just a copy

  const newFilterTableFilters = removeKeyObjects({ ...newFilter }, TABLE_POD_QUERY_KEYS); // {y:...}

  const filterPodKeys = getFilterPodKeys(filterPodState);

  const res = {};
  for (const k of filterPodKeys) {
    if (allQueries.hasOwnProperty(k)) delete allQueries[k];
    if (newFilterTableFilters.hasOwnProperty(k)) res[k] = newFilterTableFilters[k];
  }

  return { ...allQueries, ...res }; // {page: ..,size: .., y: ..}
};

export const getFilterPodKeys = (filters) => {
  const res = [];
  filters.forEach((v) => {
    const k = v?.query ?? v?.keyName ?? v?.key ?? null;
    if (k) res.push(k);
  });
  return res;
};

export const getFiltersFromUrlQuery = (location, currentFilter = []) => {
  const query = getQuery(location);
  const filters = [...currentFilter];

  for (const i in filters) {
    if (!filters[i]?.filterType?.includes('RANGE')) {
      const qVal = query[filters[i].query] ?? query[filters[i].keyName];

      if (qVal != null && qVal !== undefined) {
        switch (filters[i]?.filterType) {
          case FILTER_TYPES.date:
            filters[i].value = jMoment(enifyDateTime(`${qVal}`), 'jYYYY/jMM/jDD');
            break;
          case FILTER_TYPES.dateTime:
            filters[i].value = jMoment(enifyDateTime(`${qVal}`), 'jYYYY/jMM/jDD HH:mm:ss');
            break;
          case FILTER_TYPES.time:
            filters[i].value = jMoment(enifyDateTime(`${qVal}`), 'HH:mm:ss');
            break;
          case FILTER_TYPES.year:
            filters[i].value = jMoment(enifyDateTime(`${qVal}`), 'jYYYY');
            break;

          default:
            filters[i].value = qVal;
            break;
        }
      }
    } else {
      const qValStart = query?.[filters[i]?.query?.start];
      const qValEnd = query?.[filters[i]?.query?.end];

      switch (filters[i]?.filterType) {
        case FILTER_TYPES.dateRange:
          if (qValStart) {
            filters[i].value.start = jMoment(enifyDateTime(`${qValStart}`), 'jYYYY/jMM/jDD');
          }
          if (qValEnd) {
            filters[i].value.end = jMoment(enifyDateTime(`${qValEnd}`), 'jYYYY/jMM/jDD');
          }
          break;
        case FILTER_TYPES.dateTimeRange:
          if (qValStart) {
            filters[i].value.start = jMoment(
              enifyDateTime(`${qValStart}`),
              'jYYYY/jMM/jDD HH:mm:ss',
            );
          }
          if (qValEnd) {
            filters[i].value.end = jMoment(enifyDateTime(`${qValEnd}`), 'jYYYY/jMM/jDD HH:mm:ss');
          }
          break;
        case FILTER_TYPES.month:
          if (qValStart) {
            filters[i].value.start = jMoment(enifyDateTime(`${qValStart}`), 'jYYYY/jMM');
          }
          if (qValEnd) {
            filters[i].value.end = jMoment(enifyDateTime(`${qValEnd}`), 'jYYYY/jMM');
          }
          break;
        case FILTER_TYPES.timeRange:
          if (qValStart) {
            filters[i].value.start = jMoment(enifyDateTime(`${qValStart}`), 'HH:mm:ss');
          }
          if (qValEnd) {
            filters[i].value.end = jMoment(enifyDateTime(`${qValEnd}`), 'HH:mm:ss');
          }
          break;

        default:
          if (qValStart) filters[i].value.start = qValStart;
          if (qValEnd) filters[i].value.end = qValEnd;
          break;
      }
    }
  }
  return filters;
};
